<sdps-notification type="error" class="sdps-m-top_none" *ngIf="showSchError || tickerSymbolValidation || nameValidation || cusipSymbolValidation  ||  sedolValidation || isinValidation || specialCharValidationForIsin || specialCharValidationForSedol || specialCharValidationForCusip">
  <div class="sdps-notification__text">
    <p [innerHTML]="getConstant.rulesConstant.pleaseCorrectFollowingError"></p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li *ngFor='let msg of schErrorMsg' [innerHTML]="msg"></li>
       <li *ngIf="tickerSymbolValidation || specialCharValidationForCusip"
          [innerHTML]="sharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName">
      </li>
      <li *ngIf="specialCharValidationForIsin || specialCharValidationForSedol"
          [innerHTML]="sharedConstant.textFieldErrorMsg.invalidCharacterEnteredAlphaNumericValue">
      </li>
      <li *ngIf="nameValidation"
          [innerHTML]="sharedConstant.textFieldErrorMsg.minCharLimitErrorMsg">
      </li>
      <li *ngIf="cusipSymbolValidation"
          [innerHTML]="sharedConstant.textFieldErrorMsg.cusipShouldContain9Digits">
    </li>
       <li *ngIf="sedolValidation"
          [innerHTML]="sharedConstant.textFieldErrorMsg.sedolShouldContai7Digits">
      </li>
      <li *ngIf="isinValidation"
          [innerHTML]="sharedConstant.textFieldErrorMsg.isinShouldContai12Digits">
      </li>
    </ul>
  </div>
</sdps-notification>

<ems-toast-message *ngIf="toastMsg" #toastMessage></ems-toast-message>

<div class="add-new-rule-group">
  <h2 *ngIf="this.instGrpData.mode !== 'EDIT'" class="page-title sdps-m-bottom_large"
    [innerHTML]="getConstant.instrumentGroups.instrumentGrpStep1.addNewInstrumentGroupHeading"></h2>
  <h2
    *ngIf="this.instGrpData.mode === 'EDIT' && (sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageInstruments.uuid, '', '') && !instrumentGrpService.deletedIG)"
    class="page-title sdps-m-bottom_large"
    [innerHTML]="getConstant.instrumentGroups.instrumentGrpStep1.editInstrumentGroupHeading"></h2>
  <h2
    *ngIf="this.instGrpData.mode === 'EDIT' && !((sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageInstruments.uuid, '', '') && !instrumentGrpService.deletedIG))"
    class="page-title sdps-m-bottom_large"
    [innerHTML]="getConstant.instrumentGroups.instrumentGrpStep1.viewInstrumentGroupHeading"></h2>
    
  <ems-step-wizard [stepObj]="items" *ngIf="items"></ems-step-wizard>
</div>
